import { phrases } from './types/phrases'
import { words } from './types/words'

export const translations = {
  phrases,
  words,
}
